<template>
  <base-material-card
    color="secondary"
    icon="mdi-credit-card-multiple-outline"
    :title="$t('ente_affiliation_card')"
  >
    <v-container>
      <v-row>
        <v-autocomplete
          v-model="asdCode"
          :items="asdList"
          item-text="ragSoc"
          item-value="code"
          :disabled="stepper > 1"
          @change="resetForm"
          dense
          :label="$t('select_asd')"
        ></v-autocomplete>
      </v-row>
      <v-stepper v-model="stepper">
        <v-stepper-header>
          <v-stepper-step
            :step="1"
            :editable="stepper >= 1"
            :complete="stepper > 1"
            >{{ $t("confirm_profile_data") }}</v-stepper-step
          >

          <v-divider></v-divider>

          <v-stepper-step
            :step="2"
            :editable="stepper >= 2"
            :complete="stepper > 2"
            >{{ $t("select_affiliation_cards") }}</v-stepper-step
          >

          <v-divider></v-divider>

          <v-stepper-step
            :step="3"
            :editable="stepper >= 3"
            :complete="stepper > 3"
            >{{ $t("exec_payment") }}</v-stepper-step
          >
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content :step="1">
            <user-edit-profile
              :paramsMasterId="masterId"
              paramsMode="EDIT"
              paramsType="plain"
              :paramsIfConfirm="true"
              @isUpdated="confirmData"
            ></user-edit-profile>
          </v-stepper-content>
          <v-stepper-content :step="2">
            <view-listino-tessere
              :paramsAsdCode="asdCode"
              :paramsConfigure="true"
              paramsType="plain"
              @configured="configureProduct"
            />
          </v-stepper-content>
          <v-stepper-content :step="3">
            <select-mod-pag
              :riepilogo="riepilogo"
              @selected="confirmOrder"
            ></select-mod-pag>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-container>
  </base-material-card>
</template>

<script>
import Swal from "sweetalert2";
import userEditProfile from "@/widget/userEditProfile.vue";
import viewListinoTessere from "@/widget/viewListinoTessere.vue";
import selectModPag from "@/widget/selectModPag.vue";

export default {
  name: "buy-ente-tessere",
  components: {
    userEditProfile,
    selectModPag,
    viewListinoTessere,
  },
  props: {
    parmsAsdCode: null,
  },
  data() {
    return {
      masterId: null,
      asdCode: null,
      asdList: [],
      stepper: 1,
      selectedTessere: null,
      asdAffiliazione: null,
      pagId: null,
      dataPag: null,
      riepilogo: {
        headers: [
          { text: this.$t("item"), value: "item" },
          { text: this.$t("qta"), value: "qta", align: "right" },
          { text: this.$t("price"), value: "prezzo", align: "right" },
          { text: this.$t("total"), value: "total", align: "right" },
        ],
        items: [],
        totale: 0,
      },
    };
  },
  created() {},
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      let _ = this;

      _.chiamataAxios("GET", "/auth/portal/getUserData/").then((response) => {
        if (_.parmsAsdCode) _.asdCode = _.parmsAsdCode;
        else _.asdCode = response.data.canAcq4asd[0].code;
        _.asdList = response.data.canAcq4asd;
      });
    },
    confirmData() {
      if (this.asdCode) {
        this.stepper = 2;
        this.$globalHandler.scroll.toTop = true;
      }
    },
    resetForm() {
      this.stepper = 1;
      this.idProduct = null;
      this.productConfig = null;
    },
    confirmOrder(pagamento) {
      let params = {
        pagId: pagamento.pagId,
        dataPag: pagamento.dataPag,
        listTessere: this.selectedTessere,
        asdAffiliazione: this.asdAffiliazione,
      };

      let _ = this;
      let url = "/auth/ente/buyTessere/" + this.asdCode;
      this.chiamataAxios("POST", url, {
        dialogLoader: true,
        body: params,
      }).then((response) => {
        if (response.data.payUrl) {
          Swal.fire({
            title: _.$t("redirect_to_external_site"),
            html: _.$t("for_complete_the_payment_operation"),
          }).then((result) => {
            window.open(response.data.payUrl);
          });
        } else {
          Swal.fire({
            type: response.msg.esito ? "success" : "error",
            title: response.msg.esito
              ? _.$t("operation_successfully_completed")
              : _.$t("there_was_an_error"),
            html: response.msg.msgTxt,
          });
        }
        _.$router.push("/portal/");
      });
    },

    configureProduct(configured) {
      let _ = this;
      // Prepara ordine e riepilogo
      _.riepilogo.totale = 0;
      _.riepilogo.items = [];
      _.asdAffiliazione = configured.asdAffiliazione;
      _.selectedTessere = configured.tessereScelte
        .filter((tessera) => {
          return tessera.qta > 0;
        })
        .map((tessera) => {
          if (tessera.qta > 0) {
            _.riepilogo.totale += tessera.prezzo * tessera.qta;
            _.riepilogo.items.push({
              item: tessera.nome,
              qta: tessera.qta,
              prezzo: tessera.prezzo,
              total: tessera.prezzo * tessera.qta,
            });
            return { tesId: tessera.tesId, qta: tessera.qta };
          }
        });
      // Se non affiliato, aggiungo affiliazione
      if (!configured.affiliated) {
        _.riepilogo.totale += configured.priceAffiliation;
        _.riepilogo.items.push({
          item: _.$t("annual_affiliation") + ": " + configured.asdAffiliazione,
          qta: 1,
          prezzo: configured.priceAffiliation,
          total: configured.priceAffiliation,
        });
      }
      _.stepper = 3;
    },
  },
};
</script>